import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';

export const Kungsleden = () => {
  return (
    <>
      <Text size={16}>
        <FormattedMessage
          id="kungsledenDescription"
          values={{
            bold: (...chunks) => (
              <Text size={16} element="span" bold>
                {chunks}
              </Text>
            ),
            a: (...chunks) => (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.kungsleden.se/var-verksamhet/kunderbjudande/symbiotic-concept/">
                {chunks}
              </a>
            )
          }}
        />
      </Text>
    </>
  );
};
